/* src/app/components/control-module/form/calendar/calendar.component.css */
.calendar-contrl {
  background-image: url(/assets/img/calendar.png);
  width: 2.75rem;
  background-repeat: no-repeat;
  background-size: 23px;
  background-position: center;
  z-index: 0;
}
/*# sourceMappingURL=calendar.component.css.map */
